export default {
  COMPROBAR_CAMARA: 'COMPROBAR_CAMARA',
  COMPROBAR_CAMARA_SUCCESS: 'COMPROBAR_CAMARA_SUCCESS',
  GET_VIDEO_CAMARA: 'GET_VIDEO_CAMARA',
  GET_IMAGEN_CAMARA: 'GET_IMAGEN_CAMARA',
  GET_IMAGEN_CAMARA_SUCCESS: 'GET_IMAGEN_CAMARA_SUCCESS',
  APAGAR_CAMARA: 'APAGAR_CAMARA',
  APAGAR_CAMARA_SUCCESS: 'APAGAR_CAMARA_SUCCESS'
}